module.exports = __webpack_public_path__ + "img/presidente.79af1b18.png";